import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { goToRegisterLeads, onClosePopup, onCopyLinkAction, onLoadAction, onPLJLoadCompleteAction, onShareLinkAction, TestAction } from './actions';
import { heightMap } from '../../configs/height';
import { generateShortTokenPlJ } from '../partnerWeb_Dashboard/utils';
import { AppLink, QUERY_PARAMS } from '../../configs/constants';
import { partnerApi, StoreKey } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import { getParametersFromURL, isMobile } from "../../configs/utils";
import { isDefaultPlatform } from "../../configs/uri-config-utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService, { BUILD_TYPE, getBuildType } from "../../SharedPropsService";
const _isMobile = isMobile();
const user_Id = null;
export const template = async (label, isPartnerPlatform, platform, isFromCheckLimitMFC, partnerAccountId, leadAuthToken, phoneNumber, pan, isFromPartnerApp, pldId, height, shareLink, partnerName, partnerInterestRate, name, trackingId, plkTK, currentActiveTabIndex, currentPage, searchContext, pljLinkFromFB) => ({
    layout: {
        id: ROUTE.VOLT_APP,
        type: isMobile() ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.VOLT_APP],
            alignment: ModalAlignmentEnum.RIGHT,
        },
        widgets: [{ id: 'pljJourneyPage', type: WIDGET.PLJ_JOURNEY_PAGE }],
    },
    datastore: {
        pljJourneyPage: {
            height: height,
            eventAction: {
                routeId: ROUTE.VOLT_APP,
                type: ACTION.GO_TO_REGISTER,
                payload: {}
            },
            onLoadCompleteAction: {
                routeId: ROUTE.VOLT_APP,
                type: ACTION.ON_LOAD_PLJ_ACTION,
                payload: {
                    pldId: pldId,
                    isFromCheckLimitMFC,
                }
            },
            closeAction: {
                routeId: ROUTE.VOLT_APP,
                type: ACTION.CLOSE_POP_UP,
                payload: { currentActiveTabIndex, currentPage, searchContext }
            },
            url: isFromCheckLimitMFC ?
                `${getBuildType() !== BUILD_TYPE.PARTNER_PRODUCTION && pljLinkFromFB ? pljLinkFromFB : AppLink}${isPartnerPlatform ? `partnerPlatform` : ''}?${isPartnerPlatform ? `platform=${platform}&` : ''}isCheckLimitMFC=true&partnerAccountId=${partnerAccountId}&source=PARTNER_DASHBOARD&showVoltDefaultHeader=false&leadtoken=${leadAuthToken}&phonenumber=${phoneNumber?.slice(3)}&pan=${pan}&plj=true` :
                // `${AppLink}${isPartnerPlatform ? `partnerPlatform` : ''}?${isPartnerPlatform ? `platform=${platform}&hideSKDIntroPage=true&` : ''}plj=true${isFromPartnerApp && `&${QUERY_PARAMS.IS_FROM_PARTNER_APP}=true${trackingId ? `trackingId=${trackingId}&` : ''}`}`,
                `${getBuildType() !== BUILD_TYPE.PARTNER_PRODUCTION && pljLinkFromFB ? pljLinkFromFB : AppLink}${isPartnerPlatform ? 'partnerPlatform' : ''}?${isPartnerPlatform ? `platform=${platform}&hideSKDIntroPage=true&` : ''}plj=true${trackingId ? `&trackingId=${trackingId}` : ''}${isFromPartnerApp ? `&${QUERY_PARAMS.IS_FROM_PARTNER_APP}=true` : ''}${plkTK ? `&${QUERY_PARAMS.PLJ_SHORT_TOKEN}=${plkTK}` : ''}`,
            width: isMobile() ? '100%' : '500',
            userFullName: label,
            shareLinkAction: {
                type: ACTION.ON_SHARE_LINK,
                routeId: ROUTE.VOLT_APP,
                payload: {
                    link: shareLink,
                    userFullName: partnerName || name,
                    partnerInterestRate: partnerInterestRate
                }
            },
            copyLinkAction: {
                type: ACTION.ON_COPY_LINK,
                routeId: ROUTE.VOLT_APP,
                payload: {
                    link: shareLink,
                    userFullName: partnerName || name,
                    partnerInterestRate: partnerInterestRate
                }
            },
            copyLinkText: "Copy link"
        },
    },
});
export const voltAppMF = {
    onLoad: async ({ asyncStorage, network, getHeight, removeWidgets, instrumentTrack }, { borrowerAccountId, name, isFromCheckLimitMFC, leadAuthToken, user, userDetails, doesEmailExist, shareLink, partnerInterestRate, isFromNonRegisteredCustomer, userPhoneNumber, userApplicationId, currentActiveTabIndex, currentPage, searchContext, }) => {
        const trackingId = await AsyncStorage.getItem('trackingId');
        await removeWidgets(ROUTE.VOLT_APP, [
            { id: "pljJourneyPage", type: WIDGET.PLJ_JOURNEY_PAGE }
        ]);
        const partnerUser = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const partnerName = partnerUser.linkedPartnerAccounts[0].partnerName;
        const customerPhoneNumber = userPhoneNumber ? userPhoneNumber : userDetails?.borrowerAccountProfile?.phoneNumber;
        const customerApplicationId = userApplicationId ? userApplicationId : userDetails?.creditApplication?.applicationId;
        let label = '';
        const header = await getAppHeader();
        header.Authorization = `Bearer ${await asyncStorage.get(StoreKey.accessToken)}`;
        const PLJ_borrowerAccountId = await asyncStorage.get(StoreKey.PLJ_borrowerAccountId);
        const pldId = borrowerAccountId ? borrowerAccountId : PLJ_borrowerAccountId;
        const params = getParametersFromURL();
        const isFromPartnerApp = params?.[QUERY_PARAMS.IS_FROM_PARTNER_APP];
        let phoneNumber = '';
        let pljName = await AsyncStorage.getItem("pljName");
        let pan = '';
        if (isFromCheckLimitMFC) {
            label = user?.fullName ? user?.fullName : user?.leadName ? user?.leadName : user?.leadPhoneNumber ? user?.leadPhoneNumber : user?.phoneNo ? user?.phoneNo : user?.borrowerAccountProfile?.phoneNumber;
            phoneNumber = user?.leadPhoneNumber ? user?.leadPhoneNumber : user?.phoneNo ? user?.phoneNo : user?.borrowerAccountProfile?.phoneNumber;
            pan = user?.panNumber ? user?.panNumber : user?.borrowerAccountProfile?.panNumber;
            label = label?.includes('+') ? label?.slice(3) : label;
        }
        else {
            if (pljName === null || pljName === '' || pljName === undefined) {
                label = customerPhoneNumber;
            }
            else {
                label = pljName;
            }
        }
        let sharePLJLink;
        if (shareLink !== undefined) {
            sharePLJLink = shareLink;
        }
        else if (!isFromCheckLimitMFC) {
            await network
                .get(`${partnerApi.referralLink}${customerApplicationId}`, {
                headers: await getAppHeader(),
                handleFromMF: true
            }, null, {
                width: heightMap[ROUTE.VOLT_APP]
            })
                .then(async (res) => {
                if (res.status === 200) {
                    sharePLJLink = res.data.link;
                }
                else {
                }
            });
        }
        let interestRate;
        if (partnerInterestRate) {
            interestRate = partnerInterestRate;
        }
        else {
            await SharedPropsService.getFirebaseConfig()?.partner_interest_rate;
        }
        const userData = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const partnerAccountId = userData?.linkedPartnerAccounts[0]?.accountId;
        let isPartnerPlatform = false;
        let platform = '';
        if (!isDefaultPlatform(userData)) {
            isPartnerPlatform = true;
            platform = `${userData?.linkedPlatformAccounts[0]?.platformCode}`;
        }
        let initiated = false;
        let completed = false;
        let redirected = false;
        const handleMessage = (event) => {
            if (event.data.includes('PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED')) {
                instrumentTrack('PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED', { trackingId: trackingId });
                initiated = true;
            }
            if (event.data.includes('PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED')) {
                instrumentTrack('PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED', { trackingId: trackingId });
                completed = true;
            }
            if (event.data.includes('PLJ_REDIRECT_USER_TO_APP')) {
                instrumentTrack('PLJ_REDIRECT_USER_TO_APP', { trackingId: trackingId });
                redirected = true;
            }
            if (initiated && completed && redirected) {
                window.removeEventListener('message', handleMessage);
            }
        };
        window.addEventListener('message', handleMessage);
        let plkTK;
        if (!isFromNonRegisteredCustomer) {
            plkTK = await generateShortTokenPlJ(pldId, network, asyncStorage, { instrumentTrack, trackingId });
        }
        const pljLinkFromFB = await SharedPropsService.getFirebaseConfig()?.plj_app_url;
        await instrumentTrack("PLJ_APP_BUNDLE_LOADING_INITIATED", { trackingId: trackingId });
        return Promise.resolve(template(label, isPartnerPlatform, platform, isFromCheckLimitMFC, partnerAccountId, leadAuthToken, phoneNumber, pan, isFromPartnerApp, pldId, getHeight(), sharePLJLink, partnerName, interestRate, name, trackingId, plkTK?.jwt, currentActiveTabIndex, currentPage, searchContext, pljLinkFromFB));
    },
    actions: {
        [ACTION.TEST_ACTION]: TestAction,
        [ACTION.ON_LOAD]: onLoadAction,
        [ACTION.CLOSE_POP_UP]: onClosePopup,
        [ACTION.GO_TO_REGISTER]: goToRegisterLeads,
        [ACTION.ON_LOAD_PLJ_ACTION]: onPLJLoadCompleteAction,
        [ACTION.ON_COPY_LINK]: onCopyLinkAction,
        [ACTION.ON_SHARE_LINK]: onShareLinkAction,
    },
    action: {
        type: ACTION.ON_LOAD,
        routeId: ROUTE.VOLT_APP,
        payload: {
            value: user_Id,
        },
    },
};
